import { motion } from "framer-motion";

function Footer() {
  return (
    <footer className="flex font-apfelgrotezk bg-strawberry bg-opacity-80 text-sm tablet:text-base desktop:text-lg justify-between items-end px-2 py-4 sm:px-4 sm:pb-8 fixed left-0 right-0 bottom-0 z-50 lg:px-8">
      <a
        className="text-base tablet:text-lg"
        href="https://2022.touchpointsfu.ca"
        target="_blank"
        rel="noreferrer"
      >
        2022 site
      </a>
      <motion.a
        href="https://www.eventbrite.ca/e/536551890147/"
        target="_blank"
        rel="noreferrer"
        className="bg-transparent hover:bg-chocolate hover:text-strawberry transition-all duration-300 
          border border-chocolate text-2xl px-2 py-1 desktop:hidden"
      >
        BUY TICKETS
      </motion.a>
    </footer>
  );
}

export default Footer;
